<template>
  <div class="container-fluid">

    <div v-for="err in errors" :key="err.field" class="alert alert-danger">
      {{err.value}}
    </div>

    <h4 class="m-3">Изменить приемущества</h4>

    <el-form ref="form" :model="form" label-width="120px" id="uploadForm" name="uploadForm" enctype="multipart/form-data">
        <el-form-item label="Название">
            <el-input v-model="form.title"></el-input>
        </el-form-item>

        <el-form-item label="Сортировка">
            <el-input v-model="form.sort"></el-input>
        </el-form-item>

        <el-form-item label="Активность">
            <el-checkbox v-model="form.activity"></el-checkbox>
        </el-form-item>

        <el-form-item label="Изображение">
          <el-upload
          action=""
          list-type="picture"
          :file-list="fileList"
          :limit="1"
          :auto-upload="false"
          :on-change="handleChange"
          >
            <el-button size="small" type="primary">Добавить Изображение</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item>
            <el-button type="primary" @click="storeAdvantage()">Изменить</el-button>
            <el-button @click="back()">Отмена</el-button>
        </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import getErrors from '../../composable/utils/getErrors';
import getFileList from '../../composable/utils/getFileList';
import useFormData from '../../composable/useFormData';

export default {
  data: function (){
    return {
      form: {
        title: '',
        sort: 0,
        activity: true,
        image: '',
      },
      errors: [],
      status: 0,
      fileList: [],
      idBanner: this.$route.params.id,
    }
  },
  mounted(){
      this.initialize()
  },
  methods:{
    back(){
        this.$router.go(-1);
    },
    storeAdvantage(){
        const { execute } = useFormData()

        const data = execute().setFields([
          'image',
          'title',
          'activity',
          'sort'
        ]).getFormData(this.form)

        axios.post(`advantage/${this.idBanner}`,data).then(()=>{
            this.back();
        }).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
            if(errors.response.status === 422) {
              this.setErrors(errors.response.data.errors)
            }
        });
    },
    getAdvantage: function (){
        axios.get('/advantage/'+this.idBanner).then((response)=>
            {
                this.setFormData(response.data);
                this.setFileList(response.data.img);
            }
        ).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
        });
    },
    handleChange(v){
      this.form.image = v?.raw || undefined
    },
    setErrors(err) {
      this.errors = getErrors(err)
    },
    setFormData(value) {
        this.form.title = value?.title || '';
        this.form.sort = value?.sort || 0;
        this.form.activity = value?.activity || false;
    },
    setFileList(value){
      this.fileList = getFileList(value)
    },
    initialize(){
        this.getAdvantage()
    }

  }
}
</script>
